import {useTranslation} from 'react-i18next';

import {Box, SxProps, Theme, Typography} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

export interface Props {
  message?: string;
  sx?: SxProps<Theme>;
}

export const EmptyStateCard = ({message, sx}: Props) => {
  const {t} = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        py: 3,
        ...sx,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 480,
          bgcolor: 'background.paper',
          border: `1px solid ${orangeColors[3]}`,
          borderRadius: '16px',
          px: 3,
          py: 4,
          textAlign: 'center',
        }}
      >
        <Typography variant='body1' sx={{color: greenColors[700]}}>
          {message ?? t('shared.emptyState')}
        </Typography>
      </Box>
    </Box>
  );
};
